var exports = {
  "G": "unreadBorder__IuApXO",
};

module.exports = exports;
